import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import InputText from "../components/Form/InputText";
import { WITH_APP } from "./PaymentMethod";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function PaymentWithApp() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // Reset specific fields if the selected compensation is not WITH_APP
    useEffect(() => {
        if (formData.paymentmethod === WITH_APP) {
            setFormData((prev) => ({
                ...prev,
                cardnumber: "",
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/ersattning-for");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={Yup.object().shape({
                    phonenumberapp: Yup.string().required(
                        "Vänligen fyll i ditt telefonnummer"
                    ),
                    ticketnumber: Yup.string()
                        .required("Vänligen fyll i ditt biljett-ID")
                        .min(7, "Biljett-ID måste innehålla 7 tecken")
                })}

            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"40"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Jag hade biljetten i appen
                                </h2>

                                <p>
                                    För att gå vidare behöver vi ha ditt mobilnummer och ditt biljett-ID.
                                </p>
                                <p>
                                    För att hitta biljett-ID trycker du fram din biljett i appen.
                                    Klicka på menyn (de tre prickarna uppe till höger) och välj ”Se biljettdetaljer”.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="phonenumberapp"
                                    label={
                                        <>
                                            Mitt mobilnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="tel"
                                    autocomplete={"off"}
                                    numbersOnly
                                />

                                <InputText
                                    name="ticketnumber"
                                    label={
                                        <>
                                            Biljett-ID <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    moreinfo="7 tecken"
                                    type="text"
                                    autocomplete={"off"}
                                    maxLength={7}
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
